import {
  CONTENT_FEEDS_RESOURCE,
  DEVICE_GROUPS_RESOURCE,
  DEVICE_UNGROUP_WRAPERS_RESOURCE,
  DEVICE_SCREENSHOTS_RESOURCE,
  DEVICES_RESOURCE,
  SCHEDULED_CONTENT_BULK_UPDATE_RESOURCE,
  SCHEDULED_CONTENT_RESOURCE,
  SCHEDULED_DAILY_CONTENT_BULK_UPDATE_RESOURCE,
  SCHEDULED_DAILY_CONTENT_RESOURCE,
  SPECIAL_CONTENT_RESOURCE,
  UNGROUPED_DEVICES_RESOURCE,
} from '../api/resources';
import { addResource, deleteResource, fetchResource, updateResource } from './remote';
import { SEARCH_DEVICES } from "signoxe/constants/actionTypes";
import { API_ROOT } from "signoxe/constants/config";

export const fetchDeviceGroups = fetchResource(DEVICE_GROUPS_RESOURCE);
export const fetchSingleDeviceGroups = fetchResource(DEVICE_GROUPS_RESOURCE, true);
export const addDeviceGroup = addResource(DEVICE_GROUPS_RESOURCE);
export const updateDeviceGroup = updateResource(DEVICE_GROUPS_RESOURCE);
export const deleteDeviceGroup = deleteResource(DEVICE_GROUPS_RESOURCE);
export const deleteContentFeed = deleteResource(CONTENT_FEEDS_RESOURCE);

export const fetchDeviceUngroupedWrapers = fetchResource(DEVICE_UNGROUP_WRAPERS_RESOURCE);
export const addDeviceUngroupedWrapers = addResource(DEVICE_UNGROUP_WRAPERS_RESOURCE);
export const updateDeviceUngroupedWrapers = updateResource(DEVICE_UNGROUP_WRAPERS_RESOURCE);
export const deleteDeviceUngroupedWrapers = deleteResource(DEVICE_UNGROUP_WRAPERS_RESOURCE);

export const fetchUngroupedDevices = fetchResource(UNGROUPED_DEVICES_RESOURCE);

export const updateDevice = updateResource(DEVICES_RESOURCE);
export const requestDeviceScreenShot = addResource(
  DEVICES_RESOURCE,
  'screenshot',
  { success: 'ScreenShot request sent.', error: 'Unable to send request.' },
);
export const requestDeviceScreenShotBurst = addResource(
  DEVICES_RESOURCE,
  'screenshot_burst',
  { success: 'ScreenShot request sent.', error: 'Unable to send request.' },
);

export const addPriorityMessage = addResource(DEVICE_GROUPS_RESOURCE, 'priority_message');
export const updatePriorityMessage = updateResource(DEVICE_GROUPS_RESOURCE, 'priority_message');
export const disablePriorityMessage = deleteResource(DEVICE_GROUPS_RESOURCE, 'priority_message');

export const fetchDeviceScreenShots = fetchResource(DEVICE_SCREENSHOTS_RESOURCE);

export const updateContentFeed = updateResource(CONTENT_FEEDS_RESOURCE);

export const enableDeviceGroupSchedule = addResource(DEVICE_GROUPS_RESOURCE, 'enable_scheduling');
export const disableDeviceGroupSchedule = addResource(DEVICE_GROUPS_RESOURCE, 'disable_scheduling');

export const addSchedule = addResource(SCHEDULED_CONTENT_RESOURCE);
export const updateSchedule = updateResource(SCHEDULED_CONTENT_RESOURCE);
export const bulkUpdateSchedule = addResource(SCHEDULED_CONTENT_BULK_UPDATE_RESOURCE);
export const deleteSchedule = deleteResource(SCHEDULED_CONTENT_RESOURCE);

export const addDailySchedule = addResource(SCHEDULED_DAILY_CONTENT_RESOURCE);
export const updateDailySchedule = updateResource(SCHEDULED_DAILY_CONTENT_RESOURCE);
export const bulkUpdateDailySchedule = addResource(SCHEDULED_DAILY_CONTENT_BULK_UPDATE_RESOURCE);
export const deleteDailySchedule = deleteResource(SCHEDULED_DAILY_CONTENT_RESOURCE);

export const addSpecialContent = addResource(SPECIAL_CONTENT_RESOURCE);
export const updateSpecialContent = updateResource(SPECIAL_CONTENT_RESOURCE);
export const deleteSpecialContent = deleteResource(SPECIAL_CONTENT_RESOURCE);

export const fetchPagedDeviceGroups = (url) =>
  fetchResource(DEVICE_GROUPS_RESOURCE, false, url)();

export const searchDevices = (query) => ({ type: SEARCH_DEVICES, query });

const getAuthTokenHeader = () => `Bearer ${localStorage.getItem("token")}`;


export const getEmailLogReport = async (slug) => {
  const url = `${API_ROOT}email-logs/${slug}/`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: getAuthTokenHeader(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (err) {
    console.error('Error fetching report log:', err);
    throw err;
  }
};

export const downloadCampaignReport = async (slug) => {
  const url = `${API_ROOT}email-logs/${slug}/download_campaign_report/`; // Adjust the URL to match your Django URL pattern
  const authToken = getAuthTokenHeader();
  const options = {
    method: 'GET',
    headers: {
      Authorization: authToken,
    },
  };

  try {
    const response = await fetch(url, options);

    if (response.ok) {
      // Create a Blob from the response data
      const blob = await response.blob();

      // Create a temporary URL to the Blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link element to trigger the download
      const a = document.createElement('a');
      a.href = url;
      a.download = 'campaign_report.csv'; // Set the desired file name
      a.click();

      // Clean up by revoking the temporary URL
      window.URL.revokeObjectURL(url);
    } else {
      console.error('Error downloading campaign report:', response.statusText);
    }
  } catch (err) {
    console.error('Error fetching campaign report:', err);
    throw err;
  }
};

export const downloadDeviceReport = async (slug) => {
  const url = `${API_ROOT}email-logs/${slug}/download_device_report/`; // Adjust the URL to match your Django URL pattern
  const authToken = getAuthTokenHeader();
  const options = {
    method: 'GET',
    headers: {
      Authorization: authToken,
    },
  };

  try {
    const response = await fetch(url, options);

    if (response.ok) {
      // Create a Blob from the response data
      const blob = await response.blob();

      // Create a temporary URL to the Blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link element to trigger the download
      const a = document.createElement('a');
      a.href = url;
      a.download = 'device_report.csv'; // Set the desired file name
      a.click();

      // Clean up by revoking the temporary URL
      window.URL.revokeObjectURL(url);
    } else {
      console.error('Error downloading campaign report:', response.statusText);
    }
  } catch (err) {
    console.error('Error fetching campaign report:', err);
    throw err;
  }
};



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/device.js